/** @format */

import { Divider } from 'antd';

export default function CustomDivider(props) {
	return <Divider {...props} />;
}
